import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DnCoinComponent } from './dn-coin.component';

@NgModule({
  declarations: [DnCoinComponent],
  imports: [CommonModule],
  exports: [DnCoinComponent],
})
export class DnCoinModule {}
